import React from "react";
import { Wrapper, Checkbox as StyledCheckbox, Label } from "./style";

const Checkbox = ({ ...rest }) => <StyledCheckbox {...rest} type="checkbox" />;
const CheckboxWithLabel = ({ label, ...rest }) => (
  <Wrapper>
    <Label>{label}</Label>
    <Checkbox {...rest} />
  </Wrapper>
);

export { Checkbox, CheckboxWithLabel };



// WEBPACK FOOTER //
// ./src/components/checkbox/index.js